const apiUrl = {
  // Base URL
  // BASE_URL: "https://0da2-13-234-124-191.in.ngrok.io/api/",

  // Login Page
  GET_OTP: "/user/send_otp/",
  GENERATE_token: "/user/generate_token/",
  VALIDATE_OTP: "/user/validate_otp/",

  /* ****  ****  **** **** **** **** **** **** **** ****   */

  //NBFC Profile API
  GET_NBFC_PROFILE: "/master/get_nbfc_profile/",
  GET_NBFC_LOGO: "master/get_nbfc_logo/",

  //  Master API
  GET_HIERARCHY_LIST: "/master/get_management_hierarchy_list/",
  GET_ROLE_LIST: "/master/get_management_role_list/",
  GET_PRODUCT_TYPE_LIST: "/master/get_product_type_list/",
  GET_LOAN_TYPE_LIST: "/master/get_loan_type_list/",
  GET_LOAN_SUB_TYPE_LIST: "/master/get_loan_subtype_list",
  GET_FREQUENCY_LIST: "/master/get_charges_frequency_list/",
  GET_TIME_PERIOD_LIST: "/master/get_time_period_list/",
  GET_TENURE_LIST: "/master/get_tenure_list/",
  GET_VIDEO_CALL_TIMING_LIST: "/master/get_video_call_timing_list/",
  GET_VAS_CHARGES_LIST: "/master/get_vas_charges_list/",
  GET_CALL_TAG_LIST: "master/get_call_tags/", // GET
  GET_STATE_LIST: "/master/state_list/",
  GET_DOC_TYPE_LIST: "/master/doc_type_list/",
  GET_PAYMENT_MODE_LIST: "/master/get_payment_mode_list/",
  GET_LOAN_PURPOSE_LIST: "/master/loan_pupose_list/",
  GET_NBFC_LIST: "/master/get_nbfc_list/",
  GET_BRAND_LIST: "master/get_or_create_vehicle_brand/",
  GET_MODEL_LIST: "master/get_or_create_vehicle_model/",
  GET_MASTER_ASSOCIATES_DATA: "master/get_master_associates_data/",
  DELETE_MASTER_ASSOCIATES_DATA: "master/delete_master_associates_data/",
  ADD_MASTER_ASSOCIATES_DATA: "master/create_master_associates_data/",
  GET_CITY_BY_PINCODE: "/master/get_city_by_pincode/", // GET -- params: pincode
  /* ****  ****  **** **** **** **** **** **** **** ****   */

  //Create or Get vehicle brand
  ADD_VEHICLE_BRAND: "/master/get_or_create_vehicle_brand/",
  ADD_VEHICLE_MODEL: "/master/get_or_create_vehicle_model/",

  // Teams API
  TEAM_LIST_API: "team/get_teammember_list/",
  ADD_TEAM_MEMBER: "/team/add_teammember_info/",
  GET_TEAM_DETAILS: "/team/get_teammember_info/",
  PATCH_TEAM_DETAILS: "/team/edit_teammember_info/",
  DELETE_TEAM_DETAILS: "/team/delete_teammember_info/",
  MAKE_TEAMMEMBER_ACTIVE_INACTIVE: "/team/make_teammember_active_inactive/",
  // GET ?mobile=&exclude_id= -- active teammates on a contact number (+ dealer flag)
  TEAM_CONTACT_HOLDERS: "/team/contact_holders/",
  GET_LOGGED_USER_INFO: "/team/get_logged_in_teammember_info/",
  GET_ACTIVE_EXECUTIVE_LIST: "/team/get_active_teammember_list/", // GET
  GET_DEALER_LIST: "/team/get_dealer_list/",

  // Administration > Delete Requests: borrower account-deletion queue.
  // Approve is the only write; the backend gates it on DELETE REQUESTS - EDIT.
  GET_ACCOUNT_DELETION_REQUESTS: "/admin/account_deletion_requests/",
  APPROVE_ACCOUNT_DELETION_REQUEST: (id) =>
    `/admin/account_deletion_requests/${id}/approve/`,
  MAKE_DEALER_ACTIVE_INACTIVE: "/team/make_dealer_active_inactive/",
  DEALER_PARTNER_ACCESS: "/team/dealer_partner_access/", // PUT `${id}/` {access: bool} -- partner dashboard access
  DEALER_PARTNER_PRODUCTS: "/team/dealer_partner_products/", // PUT `${id}/` {products: [ids]} -- Salary Advance always kept
  DEALER_PARTNER_VIEW: "/team/dealer_partner_view/", // POST `${id}/` -- a 5-minute view-only pass to that DSA's partner pages
  DEALER_PARTNER_SETTINGS: "/team/dealer_partner_settings/", // GET / PUT `${id}/` -- login mobile+email, products, permissions, sign-in log
  DEALER_API_ACCESS: "/team/dealer_api_access/", // PUT `${id}/` {access: bool} -- partner API access
  DEALER_API_PASSWORD: "/team/dealer_api_password/", // `${id}/` GET show / POST generate or renew / DELETE revoke -- the dealer's API password
  GET_DEALER_BANK_DETAILS: "/team/get_dealer_bank_details/",
  GET_SUPER_ADMIN: "/team/get_superadmin_list/",
  // Accept EMI approval (lms/accept_emi_approval.py): who may approve, and the code to them.
  ACCEPT_EMI_APPROVERS: "/lms_loan/accept_emi_approvers/",
  ACCEPT_EMI_CODE: "/lms_loan/accept_emi_code/",
  GET_DEALER_PRODUCT: "/team/get_dealer_product_permission/",
  // Access (permission groups + per-teammate permissions)
  PERMISSION_CATALOGUE: "/team/permission_catalogue/", // GET
  MY_ACCESS: "/team/my_access/", // GET
  PERMISSION_GROUPS: "/team/permission_groups/", // GET/POST; GET/PUT/DELETE -- look_up_key: id
  PERMISSION_GROUP_MEMBERS: "/team/permission_groups/", // GET/POST -- `${id}/members/`
  MEMBER_ACCESS: "/team/member_access/", // GET/PUT -- look_up_key: member id
  REJECT_DELETE_REQUEST: "/admin/account_deletion_requests/", // POST -- `${id}/reject/`
  DELETE_REPORT: "/reports/delete_report/", // DELETE -- look_up_key: id

  /* ****  ****  **** **** **** **** **** **** **** ****   */

  // Loan Scheme API
  GET_LOAN_SCHEME: "/loanschema/get_loanscheme_list/",
  MAKE_LOAN_SCHEME_MEMBER_ACTIVE_INACTIVE:
    "/loanschema/make_loanscheme_active_inactive/",
  DELETE_LOAN_SCHEME_DETAILS: "/loanschema/delete_loanscheme_info/",
  ADD_INSURANCE_FEE: "/loanschema/add_loan_insurance_fee/",
  ADD_PROCESSING_FEE: "/loanschema/add_loan_processing_fee/",
  ADD_LOANSCHEME_INFO: "/loanschema/add_loanscheme_info/",
  GET_LOAN_SCHEME_DETAILS: "/loanschema/get_loanscheme_info/",
  PATCH_LOAN_SCHEME_DETAILS: "/loanschema/edit_loanscheme_info/",

  /* ****  ****  **** **** **** **** **** **** **** ****   */

  // Borrower  LOS
  GET_BORROWER_COMPLETE_INFO: "/borrower/get_borrower_complete_info/",
  UPDATE_BORROWER_COMPLETE_INFO: "/borrower/update_borrower_complete_info/",
  ADD_BORROWER_COMPLETE_INFO: "/borrower/admin_create_borrower_complete_info/",
  UPLOAD_BORROWER_DOCUMENTS: "/borrower/admin_upload_borrower_documents/", // PUT -- look_up_key: lead_creation
  CHECK_EXISTING_BORROWER: "/borrower/check_borrower_info/", // GET -- params: lead_creation
  GET_EXTRA_INFO: "/borrower/extra_info/", // GET -- params: lead_creation
  GET_CIBIL_LIST: "/borrower/cibil_list/", // GET -- params: lead_creation
  GET_CIBIL_DETAIL: "/borrower/cibil_detail/",
  ADD_BUSINESS_LOAN_BORROWER_BASIC_DETAIL:
    "/bl_borrower/create_bl_borrower_basic_info/",
  UPDATE_BL_BORROWER_BASIC_DETAIL:
    "/bl_borrower/update_bl_borrower_basic_info/",
  ADD_BUSINESS_LOAN_BORROWER_PERSONAL_DETAIL:
    "/bl_borrower/create_or_update_bl_borrower_personal_info/",
  ADD_BUSINESS_LOAN_BORROWER_BUSINESS_DETAIL:
    "/bl_borrower/add_or_update_borrower_business_details/",
  SUBMIT_LOAN_APPLICATION_FORM: "/bl_borrower/submit_loan_application_form/",
  GL_ADD_ASSETS_DETAILS: "/gl_borrower/add_asset_details/",
  GET_UPDATE_BL_BANK_DETAILS:
    "/bl_borrower/get_or_update_business_bank_details/",
  GET_BL_BORROWER_DETAILS: "/admin/get_bl_borrower_details/",
  GET_ASSIGNED_AGENT: "/los_loan/get_assigned_agent/", // GET -- look_up_key: lead_creation, params: loan_status
  REQUEST_KYC: "/los_loan/request_kyc/", // GET -- look_up_key: lead_creation
  REQUEST_BANK_STATEMENT: "/los_loan/request_bank_statement/", // GET -- look_up_key: lead_creation
  REQUEST_CREDIT_REPORT: "/los_loan/request_credit_report/", // GET -- look_up_key: lead_creation
  // Karrofin CredForge AI Analysis
  AI_ANALYSIS_DATA: "/verification/ai_analysis/", // GET -- look_up_key: lead_creation
  AI_ANALYSIS_SKIP: "/verification/ai_analysis/", // POST -- + lead_creation + "/skip/"
  AI_ANALYSIS_CLEAR_DEVIATED: "/verification/ai_analysis/", // POST -- + lead_creation + "/clear_deviated/"
  AI_ANALYSIS_RERUN: "/verification/ai_analysis/", // POST -- + lead_creation + "/rerun/"
  GET_CREDIT_REPORT_STATUS: "/los_loan/credit_report_status/", // GET -- look_up_key: lead_creation
  GET_LOAN_FORM_PREFILL_DATA: "/los_loan/get_prefill_data/", // GET -- look_up_key: lead_creation
  GET_BORROWER_FINVU_DATA: "/borrower/get_borrower_finvu_data/", // GET -- look_up_key: lead_creation
  ADD_MANUAL_BANK_DATA: "/los_loan/add_manual_bank_data/", // POST -- look_up_key: lead_creation
  UPDATE_MANUAL_BANK_DATA: "/los_loan/update_bank_data_info/", // PATCH -- look_up_key: bank_id
  PUSH_LEAD_TO_LOS: "/los_loan/push_loan_to_los/", // GET -- look_up_key: lead_creation
  ASSIGN_DEALER_FROM_LOS: "/los_loan/assign_dealer_from_los/",

  /* ****  ****  **** **** **** **** **** **** **** ****   */

  // FinVu
  GET_FINVU_DATA_LIST: "/borrower/get_borrower_finvu_data/",
  GET_FINVU_JSON_DATA: "/finvu/get_json_data/",

  // Los loan
  UPLOAD_BS_SS: "/los_loan/upload_bank_salary_document_button/", // PUT -- look_up_key: lead_creation
  UPLOAD_AOD_SS: "/los_loan/upload_address_other_document/", //POST --LOOK_UP_KEY
  CREATE_LOAN: "/los_loan/add_or_update_borrower_loan/", // PUT -- look_up_key: lead_creation

  //GET  initiated details
  GET_INITIATED_BY:"/los_loan/initiated_by/",

  GET_LOS_LOAN_LIST: "/los_loan/get_loan_list/",
  GET_TAT_BREAKDOWN: "/los_loan/get_tat_breakdown/", // GET -- look_up_key: lead_creation
  GET_LOS_REJECTION_DETAILS: "/los_loan/get_rejection_details/", // GET -- look_up_key: lead_creation -> {rejected_by, rejected_by_role, rejected_by_mode, rejected_at, rejection_reason}
  GET_BORROWER_LOAN_INFO: "/los_loan/get_borrower_loan_information/",
  ASSIGN_LOS_EXECUTIVE: "/los_loan/update_executive_assigned_to_loan/", // PUT -- look_up_key: lead_creation
  ASSIGN_DEALER_LEAD_EXECUTIVE: "/dealer/assign_executive/", // PUT -- look_up_key: dealer lead id
  // Mobile-keyed borrower internal comments — shared across LOS, LMS, Collection.
  BORROWER_COMMENT_POST: "/borrower/comment/",
  BORROWER_COMMENTS_GET: "/borrower/comments/", // GET -- look_up_key: mobile_no
  GET_EXISTING_CUSTOMERS_LIST: "/los_loan/existing_customers_list/",
  DUPLICATE_EXISTING_LOAN: "/los_loan/duplicate_existing_loan/", // GET -- look_up_key: lead_creation
  GUARANTOR_DETAILS: "/bl_borrower/guarantor_details/",
  GET_APPLICATION_LOAN_DATA: "/los_loan/get_application_loan_data/", //GET -- look_up_key: lead_creation
  UN_REJECT_LOAN: "/los_loan/", //POST -- + lead_creation + "/un_reject/"

  ADD_PL_BASIC_DETAILS: "/los_loan/add_pl_basic_details/", //POST -- params: lead_creation
  GET_PL_BASIC_DETAILS: "/los_loan/get_pl_basic_details/", // GET -- look_up_key: lead_creation
  ADD_PL_ADDITIONAL_DETAILS: "/los_loan/add_pl_additional_details/", // GET -- look_up_key: lead_creation
  GET_PL_ADDITIONAL_DETAILS: "/los_loan/get_pl_additional_details/", // GET -- look_up_key: lead_creation
  ADD_PL_ADDRESS_DETAILS: "/los_loan/add_pl_address_details/", // GET -- look_up_key: lead_creation
  GET_PL_ADDRESS_DETAILS: "/los_loan/get_pl_address_details/", // GET -- look_up_key: lead_creation

  // stepper
  GET_STEPS: "/los_loan_button/get_internal_loan_status/", // GET -- params: lead_creation
  UPDATE_LOS_LOAN_STATUS: "/los_loan_button/update_loan_status/", // look_up_key: lead_creation
  KYC_APPROVE_LOAN: "/los_loan_button/kyc_approve/", // PUT -- look_up_key: lead_creation
  SEND_BACK_TO_KYC: "/los_loan_button/send_back_to_kyc/", // PUT -- look_up_key: lead_creation; body { tools }
  MOVE_TO_CAM: "/los_loan_button/move_to_cam/", // GET state / PUT move { message } / POST keep current offer -- look_up_key: lead_creation
  // internal score
  GET_INTERNAL_SCORE: "/los_loan/get_internal_score/",
  // document verification
  GET_BORROWER_SUBMITTED_DOCUMENT: "/los_loan/get_borrower_submitted_document/",
  MAKE_DOCUMENT_VERIFIED: "/los_loan/document_is_verified_button/",
  MAKE_REQUEST_AGAIN: "/los_loan/document_requested_again_button/",
  DOCUMENT_REQUEST_BY_NAME: "/los_loan/document_request_by_name/",
  DOCUMENT_REQUEST_LIST: "/los_loan/document_requests/",
  GET_APPROVAL_FORM_DETAILS: "/los_loan/get_loan_approval_form/",
  POST_APPROVAL_FORM_DETAILS: "/los_loan/create_loan_approval_form/",
  UPLOAD_GENERAL_DOCUMENTS: "/los_loan/upload_general_document_button/", // PUT -- look_up_key: lead_creation
  UPLOAD_ADDRESS_AND_OTHER_DOC: "/los_loan/upload_address_other_document/", // PUT -- look_up_key: lead_creation
  DELETE_ADDRESS_AND_OTHER_DOC:
    "/los_loan/delete_address_other_document_button/", // PUT -- look_up_key: lead_creation
  UPLOAD_BANK_DOCUMENTS: "/los_loan/upload_bank_salary_document_button/", // PUT -- look_up_key: lead_creation
  REDO_ACCOUNT_AGGREGATOR: "/los_loan/redo_account_aggregator/", // POST -- look_up_key: lead_creation (optional ?redirect_url=)
  UPLOAD_BANK_STATEMENT: "/los_loan/upload_bank_statement/", // POST -- look_up_key: lead_creation (multipart: front_file, remarks)
  GET_UPDATE_DOCUMENTS_INFORMATION:
    "/los_loan/get_or_update_documents_information/",
  // cam
  GET_CAM_DETAILS: "/los_loan_cam/get_cam_detail/",
  GET_CAM_OFFER_LIST: "/los_loan_cam/get_cam_offer_list/", // params: lead_creation
  GENERATE_CAM_OFFER_LIST: "/los_loan_cam/create_or_update_cam_data/", // look_up_key: lead_creation
  SEND_OFFERS_TO_CUSTOMER: "/los_loan_cam/send_offer_to_customer/", // params: lead_creation
  REVERT_CAM_OFFER: "/los_loan_cam/revert_offer/", // look_up_key: lead_creation
  GET_DISCARDED_OFFERS: "/los_loan_cam/discarded_offers/", // look_up_key: lead_creation
  SELECT_OFFER: "/los_loan_cam/admin_update_offer_status/",
  // disbursal details
  GET_DISBURSAL_DETAILS: "/los_loan_charges/get_disbursal_detail/", // GET -- look_up_key: lead_creation
  ADD_VAS_CHARGES: "/los_loan_charges/add_vas_charge/", //POST -- LOOK_UP_KEY  lead ceation
  // video verification
  GET_VIDEO_CALL_SCHEDULE: "/los_loan_video/get_video_call_schedule_list/", // GET -- params: lead_creation
  GET_LAST_VIDEO_CALL_DETAILS: "/los_loan_video/get_last_video_call_detail/", //GET -- look_up_key: lead_creation
  GET_VIDEO_CALL_VERIFICATION_DETAILS:
    "/los_loan_video/get_video_call_result_list/", // GET -- look_up_key: lead_creation
  GET_SIGNATURE: "/los_loan_video/get_signature/", // POST -- look_up_key: lead_creation
  ADD_VIDEO_CALL_SCHEDULE: "/los_loan_video/add_video_schedule/", // POST -- look_up_key: lead_creation
  ADD_VIDEO_CALL_VERIFICATION_DATA:
    "/los_loan_video/add_video_call_verification/", // POST -- look_up_key: lead_creation
  UPLOAD_SIGN: "/los_loan_video/upload_signature/", // POST -- look_up_key: lead_creation
  VERIFY_SIGN: "/los_loan_video/verify_signature/", // POST -- look_up_key: lead_creation
  GENERATE_AGREEMENT: "/los_loan_video/generate_agreement_form/", // GET -- look_up_key: lead_creation
  VIEW_UNSIGNED_AGREEMENT: "/los_loan_video/view_unsigned_agreement/", // GET -- los_details "View Agreement" button; returns unsigned only
  UPLOAD_AGREEMENT: "/los_loan_video/upload_agreement/",
  INITIATE_ESIGN: "/los_loan_video/initiate_esign/",
  GET_DIGIO_STATUS: "/los_loan_video/get_digio_status/",
  GENERATE_BL_AGREEMENT: "/bl_borrower/generate_bl_agreement_form/",
  VIEW_UNSIGNED_BL_AGREEMENT: "/bl_borrower/view_unsigned_bl_agreement/", // GET -- los_details "View Agreement" button (BL/LAP)
  GET_AGREEMENT: "/los_loan_video/get_agreement/", // GET -- lead_creation -- returns signed if available, else unsigned
  DOCUMENT_PROXY: "/los_loan_video/document_proxy/", // GET -- ?url= -- streams a provider-hosted doc back with Access-Control-Allow-Origin so pdf.js can read it
  // enach
  GET_ENACH_DETAILS: "/los_loan_enach/get_enach_details/", // GET -- look_up_key: lead_creation
  UPDATE_ENACH_DETAILS: "/los_loan_enach/create_update_enach/", // PUT/PATCH -- look_up_key: lead_creation
  GET_ENACH_LINK: "/los_loan_enach/link/", // GET -- look_up_key: lead_creation -- current eNACH set-up link + status
  GENERATE_ENACH_LINK: "/los_loan_enach/link/generate/", // POST -- look_up_key: lead_creation -- body {force}; never emails
  SEND_ENACH_LINK: "/los_loan_enach/link/send/", // POST -- look_up_key: lead_creation -- emails the existing link; never generates
  GET_NACH_LIST: "/los_enach/get_nach_list/", // GET -- params: filter (created/success/failed), search, page
  GET_AUTO_DEBIT_LIST: "/payments/get_auto_debit_list/", // GET -- params: status, product, payment_type, lead, date_preset, from_date, to_date, search, page
  GET_UPCOMING_AUTO_DEBIT_LIST: "/payments/get_upcoming_auto_debit_list/", // GET -- params: product, lead, date_preset, from_date, to_date, search, page
  GET_AUTO_DEBIT_FILTERS: "/payments/get_auto_debit_filters/", // GET -- dynamic filter options {payment_types, statuses, loan_types, date_presets}
  GET_AUTO_DEBIT_LEAD_LIST: "/payments/get_auto_debit_lead_list/", // GET -- {lead_creation, borrower_name, count, label} users with auto-debit entries
  GET_NACH_LEAD_LIST: "/los_enach/get_nach_lead_list/", // GET -- list of {lead_creation, borrower_name, label} for the NACH user filter
  // payment details
  GET_PAYMENT_DETAILS: "/los_loan_payment/get_payment_details/", //GET -- look_up_key: lead_creation
  GET_PAYMENT_BREAKDOWN: "/los_loan_payment/get_payment_task_details/", //GET -- look_up_key: lead_creation
  UPDATE_BORROWER_BANK_DETAILS:
    "/los_loan_payment/update_borrower_bank_details/", // PUT/PATCH -- look_up_key: lead_creation

  VERIFY_PAYMENT_DETAILS: "/los_loan_payment/verify_payment_details/",
  // POST -- look_up_key: lead_creation, { note }: approve a bank holder name that does not match the PAN name
  APPROVE_BANK_NAME_MISMATCH: "/los_loan_payment/approve_bank_name_mismatch/",
  // POST -- look_up_key: lead_creation, { note? }: mark the personal discussion (PD) done -> {pd_done, pd_details}
  MARK_PD_DONE: "/los_loan_payment/mark_pd_done/",

  // POST -- { account_number, lead_creation? }: is this bank account already used by another customer (or this customer before)?
  CHECK_ACCOUNT_SHARED: "/los_loan_payment/check_account_shared/",
  // POST -- { account_number, lead_creation }: persist that staff accepted the shared-account warning for this loan.
  ACKNOWLEDGE_SHARED_ACCOUNT: "/los_loan_payment/acknowledge_shared_account/",

  // PAYMENT_RESYNC: "/payments/resync_payments/",

  ADD_REFERENCE_CONTACT: "/los_loan_video/add_reference_contacts/",

  // Per-NBFC dynamic borrower-form field config (visibility/required/label/
  // options/count). Append <product_type_id>/ (0 => NBFC-wide defaults).
  GET_NBFC_FORM_FIELD_PREFERENCES: "/master/get_nbfc_form_field_preferences/",

  /* ****  ****  **** **** **** **** **** **** **** ****   */

  //Account
  GET_ACCOUNT_LIST: "/accounts/get_disbursement_list/", // GET
  GET_LEDGER_LIST: "/accounts/get_ledger_list/", // GET
  POST_ACCOUNT_DISBURSEMENT:
    "/accounts/disbursement/create_update_manual_posting/",
  UNDO_ACCOUNT_DISBURSEMENT: "/accounts/approve_reject_undo_disbursement/",
  DISBURSE_TO_DEALER: "/accounts/disbursement/approve_dealer_disbursal/",
  GET_ACCOUNT_DISBURSEMENT: "/accounts/disbursement/get_posting_detail/",
  GET_DISBURSAL_DETAIL: "/accounts/get_disbursement_detail/",
  AUTO_POST: "/accounts/disbursement/auto_posting/", // POST -- look_u_key: lead_creation
  DISBURSEMENT_ACCOUNTS: "/accounts/disbursement_accounts/", // GET / POST; PATCH / DELETE -- look_up_key: id

  /* ****  ****  **** **** **** **** **** **** **** ****   */

  // ledger
  GET_BANK_LEDGER_LIST: "/ledgers/get_bank_ledgers_list/",
  GET_COMPANY_LEDGERS: "/ledgers/company_ledgers/", // GET
  // Account section: the chart of accounts and the global voucher queue.
  GET_LEDGER_CHART: "/ledgers/chart/",
  // + `${level}/${node_id}/ledgers/`
  GET_CHART_NODE_LEDGERS: "/ledgers/chart/",
  LIST_ALL_MANUAL_VOUCHERS: "/ledgers/vouchers/manual/",
  GET_UNAPPROVED_VOUCHER_COUNT: "/ledgers/vouchers/manual/pending_count/",
  GET_CUSTOMER_LEDGERS: "/ledgers/customer_ledgers/", // GET
  GET_ENTITY_LIST: "/ledgers/ledger_entries_list/", // GET -- look_up_key : id
  GET_VOUCHER_DETAILS: "/ledgers/get_voucher_detail/", // GET -- look_up_key : voucher_no
  GET_ALL_CUSTOMER_LIST: "/ledgers/all_customer_ledgers/",
  GET_CHARGE_LIST: "/los_loan/get_charge_list/",
  GET_EMI_LIST: "/los_loan/get_emi_list/",
  GET_BORROWER_PAYMENT_LIST: "/payments/get_borrower_payments/",
  GET_EMI_CHARGE_LIST: "/los_loan/get_emi_charge_list/",
  CREATE_VOUCHER: "/ledgers/create_voucher/",
  GENERATE_VOUCHER_DOC: "/ledgers/generate_voucher_doc/",
  LIST_MANUAL_VOUCHERS: "/ledgers/vouchers/list_manual_vouchers/",
  EDIT_VOUCHER: "/ledgers/vouchers/edit_voucher/",
  REJECT_VOUCHER: "/ledgers/vouchers/reject_voucher/",
  DELETE_VOUCHER: "/ledgers/delete_voucher/",
  GET_DEALER_LEDGERS_LIST: "/ledgers/dealer_ledgers/",
  ADD_JOURNAL_VOUCHER: "/ledgers/add_dealer_voucher/",

  /* ****  ****  **** **** **** **** **** **** **** ****   */

  //LMS loan
  GET_LMS_LOAN_LIST: "/lms_loan/get_loan_list/",
  GET_LMS_LOAN_INFO: "/lms_loan/get_loan_info/", //GET -- look_up_key: lead_creation
  GET_BORROWER_LOAN_LIST: "/lms_loan/get_borrower_loan_list/",
  GET_LOAN_HISTORY_COUNT: "/lms_loan/loan_history_count/", // GET -- param: lead_creation
  GET_LMS_LOAN_AMENDMENT_LIST: "lms_loan/get_amendment_list/",
  GET_LMS_DATE_AMENDMENT_PREVIEW: "lms_loan/date_amendment_preview/", // GET -- look_up_key: lead_creation, param: amendment_date
  GET_DATE_AMENDMENT_LIST: "master/get_date_amendment_list/",
  POST_LMS_LOAN_ACCEPT_EMI: "lms_loan/accept_emi/",
  POST_LMS_LOAN_DATE_AMENDMENT: "lms_loan/date_amendment/",
  ASSIGN_LMS_EXECUTIVE: "/lms_loan/update_executive_to_lms_loan/", // PUT -- look_up_key: lead_creation
  // Blacklist a customer out of any future application to this NBFC. Both take
  // look_up_key: lead_creation and a required {reason} body.
  BLACKLIST_BORROWER: "/borrower/blacklist/", // POST -- look_up_key: lead_creation
  REMOVE_BLACKLIST_BORROWER: "/borrower/remove_blacklist/", // POST -- look_up_key: lead_creation
  PAN_MOBILE_WHITELIST: "/borrower/pan_mobile_whitelist/", // GET ?pan_number= | POST {pan_number, mobile_no, reason, lead_creation}
  PAN_MOBILE_WHITELIST_ALL: "/borrower/pan_mobile_whitelist/all/", // GET ?search=&page=&page_size=
  REMOVE_PAN_MOBILE_WHITELIST: "/borrower/pan_mobile_whitelist/", // POST -- look_up_key: "<id>/remove"
  GET_SETTLEMENT_OVERVIEW: "/lms_loan/settlement_overview/",
  GET_LOAN_SCHEDULE: "/lms_loan/loan_schedule_list/", // GET -- look_up_key: lead_creation
  GET_BORROWER_LEDGER_LIST: "/ledgers/get_borrower_ledger/", // GET -- look_up_key: lead_creation
  GET_REAL_LEDGER_ENTRIES: "/ledgers/borrower/get_real_ledger_entries/", // GET -- look_up_key: lead_creation
  GET_VIRTUAL_LEDGER_ENTRIES: "/ledgers/borrower/get_virtual_ledger_entries/", // GET -- look_up_key: lead_creation
  GET_PUT_SETTLEMENT_OVERVIEW_2: "/lms_loan/settlement_phase_two_overview/", // GET -- look_up_key: lead_creation
  GET_LOAN_STATEMENT_LIST: "/loan_statement/get_loan_statement_list/",
  GET_SUIT_FILED_STATUS: "/lms_loan/get_suit_filed_status/",
  UPDATE_SUIT_FILED_STATUS: "/lms_loan/update_suit_filed_status/",
  GENERATE_LOAN_STATEMENT: `/loan_statement/generate_loan_statements/`,
  GET_STATES_LIST: "/master/get_state_list/",
  GET_BRANCH_DETAILS: "/master/get_branch_by_ifsc/",
  FINVU_GET_CONSENT_LIST: "/finvu/get_consent_list/",
  FINVU_BALANCE_HISTORY: "/finvu/balance_history/",
  FINVU_FETCH_BALANCE: "/finvu/fetch_balance/",
  /* ****  ****  **** **** **** **** **** **** **** ****   */

  //Collection of EMI
  GET_COLLECTION_LIST: "/collection_of_emi/get_collection_emi_list/", // GET
  GET_COLLECTION_PINCODE_LIST: "/collection_of_emi/get_pincode_list/", // GET
  GET_COLLECTION_EMPLOYMENT_TYPE_LIST: "/collection_of_emi/get_employment_type_list/", // GET
  GET_COLLECTION_BANK_NAME_LIST: "/collection_of_emi/get_bank_name_list/", // GET
  GET_CALL_TAG_FILTER_LIST: "/collection_of_emi/get_call_tag_filter_list/", // GET
  GET_COLLECTION_SALARY_RANGE_LIST: "/collection_of_emi/get_salary_range_list/", // GET
  GET_COLLECTION_LOAN_TENURE_LIST: "/collection_of_emi/get_loan_tenure_list/", // GET
  GET_COLLECTION_AGE_RANGE_LIST: "/collection_of_emi/get_age_range_list/", // GET
  GET_SETTLEMENT_STATUS_LIST: "/collection_of_emi/get_settlement_status_list/", // GET
  GET_UPCOMING_DAYS_LIST: "/collection_of_emi/get_upcoming_days_list/", // GET
  GET_OVERDUE_DAYS_LIST: "/collection_of_emi/get_overdue_days_list/", // GET
  GET_CONTACT_LIST: "/collection_of_emi/get_contact_list/",
  ADD_CONTACT: "/collection_of_emi/add_contact/",
  ADD_REMARK: "/collection_of_emi/add_update_contact_remark/",
  GET_REFERENCE_CONTACT: "/collection_of_emi/get_reference_contact_list/",
  MARK_ALL_CONTACTS_FAVORITE: "/collection_of_emi/mark_as_fav/",
  REF_CONTACT_FAVORITE: "/collection_of_emi/reference_mark_as_fav/",
  ADD_REF_REMARK: "/collection_of_emi/reference_update_remark/",

  // Alternate contacts -- every other number on a borrower's file. Rows with
  // source "bureau" are projected from the credit report; "manual" ones were
  // added by staff. Also returned inline on GET_BORROWER_COMPLETE_INFO as
  // `alternate_contact_information`, which is what the borrower record reads;
  // this list endpoint is for surfaces that do not load the full payload.
  // All six under /borrower/ -- deliberately not split across two apps the way
  // the reference-contact endpoints above ended up.
  GET_ALTERNATE_CONTACT: "/borrower/alternate_contacts/", // GET -- look_up_key: lead_creation
  ADD_ALTERNATE_CONTACT: "/borrower/alternate_contacts/", // POST -- look_up_key: lead_creation
  UPDATE_ALTERNATE_CONTACT: "/borrower/alternate_contact/", // PATCH -- look_up_key: id
  DELETE_ALTERNATE_CONTACT: "/borrower/alternate_contact/", // DELETE -- look_up_key: id
  ALTERNATE_CONTACT_FAVORITE: "/borrower/alternate_contact/mark_as_fav/", // PUT -- look_up_key: id
  ADD_ALTERNATE_REMARK: "/borrower/alternate_contact/update_remark/", // PUT -- look_up_key: id
  ADD_FOLLOW_UP_DATE: "/collection_of_emi/add_update_follow_up/",
  ADD_UPDATE_CALL_TAG: "/collection_of_emi/add_update_call_tags/", // PUT -- look_u_key: loan_id
  ADD_MANUAL_PAYMENT: "/collection_of_emi/manual_payment/", // POST -- look_u_key: lead_creation
  REQUEST_CHARGE: "/collection_of_emi/send_charge_request/", // POST -- look_u_key: lead_creation
  GET_CHARGES_HISTORY_LIST: "/collection_of_emi/get_charge_list/", // POST -- look_u_key: lead_creation
  GET_ADDED_CHARGE_LIST: "/collection_of_emi/get_added_charge_list/", // GET -- look_u_key: lead_creation (dialog-added charges only)
  ASSIGN_COLLECTION_EXECUTIVE: "/collection_of_emi/assign_executive/", // POST -- look_u_key: lead_creation
  MARK_FEEDBACK_DONE: "/collection_of_emi/mark_feedback_done/", // POST -- look_u_key: lead_creation
  SEND_PAYMENT_LINK: "/collection_of_emi/send_payment_link/", //post --look_up_key: lead_creation
  REGENERATE_PAYMENT_LINK: "/collection_of_emi/regenerate_payment_link/", //post --look_up_key: lead_creation
  GET_PAYMENT_LINK_STATUS: "/collection_of_emi/payment_link_status/", //get --look_up_key: lead_creation
  // GET_COURT_CASE_TAG_LIST: "/collection_of_emi/get_court_case_tag_list/", //get
  ASSIGN_COURT_CASE_TAG: "/collection_of_emi/add_update_case_tag/", //post --look_up_key: lead_creation
  //get cate tag list
  GET_CASE_TAG_LIST:"master/get_case_tags/",

  // Click-to-call (Exotel), used by Collections, LOS and Leads. Exotel rings
  // the SIGNED-IN member first, then the customer. Both numbers and the caller
  // ID are resolved server-side from the JWT and the target -- the browser
  // never sends a phone number.
  //
  // The target is `lead_creation` OR `lead_id` (a DealerLeadRecords id, for a
  // lead that has not reached LOS and so has no lead_creation yet); one is
  // required and lead_creation wins.
  // A call can also go to somebody attached to that customer -- a co-applicant,
  // guarantor or reference. Same rule applies: the browser picks them by
  // { contact_type, contact_id } and the server resolves the number.
  INITIATE_CALL: "/telephony/calls/", // POST -- body: { lead_creation | lead_id, contact_type?, contact_id? }
  GET_ACTIVE_CALLS: "/telephony/calls/active/", // GET -- live + just-ended calls for this NBFC
  GET_CALL_HISTORY: "/telephony/calls/history/", // GET -- params: lead_creation | lead_id, page
  GET_CALL_CONTACTS: "/telephony/calls/contacts/", // GET -- params: lead_creation | lead_id

  // Notification Panel
  GET_NOTIFICATION_HISTORY_LIST: "/notification/get_notification_history_list/", // GET -- lookup_key: lead_creation, params: type
  GET_NOTIFICATION_CONTACT_LIST: "/notification/get_contact_list/", // GET -- lookup_key: lead_creation
  UPDATE_CONTACT_LIST: "/notification/update_contact_list/", // POST -- lookup_key: lead_creation
  GET_SUB_STATUS_LIST: "/notification/get_sub_status_list/", // GET

  // Notifications tab -- Tracking (every message sent, from every source) and Configuration
  GET_NOTIFICATION_LOG: "/notifications/log/", // GET -- params: date_from, date_to, channel, status, source_system, sent_by_type, sent_by_user_id, triggered_from, recipient_type, stage, event_key, lead_creation, search, page, page_size
  GET_NOTIFICATION_LOG_FILTERS: "/notifications/log/filters/", // GET
  GET_NOTIFICATION_LOG_DETAIL: "/notifications/log/", // GET -- lookup_key: id
  GET_NOTIFICATION_SECTIONS: "/notifications/sections/", // GET -- the Notifications tab's sub-screens
  GET_NOTIFICATION_CONFIG: "/notifications/config/", // GET -- params: channel, the message list's filters
  GET_NOTIFICATION_CONFIG_VERSION: "/notifications/config/version/", // GET -- a stamp that changes when the setup does
  GET_NOTIFICATION_CONFIG_TEST: "/notifications/config/test/", // GET -- params: event_key, channel, to (check, no send)
  GET_NOTIFICATION_CONFIG_TEST_RESULT: "/notifications/config/test/result/", // GET -- params: id (a test's delivery result)
  NOTIFICATION_CONFIG_EDITOR: "/notifications/config/editor/", // GET -- params: kind + its params; POST -- {kind, params, values}
  GET_NOTIFICATION_CONFIG_PREVIEW: "/notifications/config/preview/", // GET -- params: kind, event_key, channel, values (JSON)
  NOTIFICATION_CONFIG_ACTION: "/notifications/config/action/", // POST -- {name, params, value}

  /* ****  ****  **** **** **** **** **** **** **** ****   */

  //Payments
  GET_PAYMENT_LIST: "/payments/get_payment_list/", // GET
  GET_PAYMENT_TYPE_LIST: "/payments/payment_type_list/",
  PAYMENT_RESYNC: "/payments/resync_payments/",
  APPROVE_MANUAL_PAYMENT: "/payments/approve_manual_payment/", // POST -- look_u_key: manual_payment_id
  REJECT_MANUAL_PAYMENT: "/payments/reject_manual_payment/", // POST -- look_u_key: manual_payment_id
  MARK_CHARGE_PAYMENT: "/payments/mark_charge_payment/", // POST -- look_up_key: payment id, body {settle_ledger_name}
  /* ****  ****  **** **** **** **** **** **** **** ****   */

  //Notice Management
  NOTICE_LIST_API: "/notice/get_notice_list/",
  DELETE_NOTICE_DETAILS: "/notice/delete_notice/",
  GET_NOTICE_DETAILS: "/notice/get_notice/",
  PATCH_NOTICE_DETAILS: "/notice/update_notice/",
  POST_NOTICE_DETAILS: "/notice/create_notice/",

  //What's New
  WHATS_NEW_LIST: "/whatsnew/get_entries/",
  WHATS_NEW_UNREAD_STATUS: "/whatsnew/unread_status/",
  WHATS_NEW_MARK_SEEN: "/whatsnew/mark_seen/",

  //noc
  GET_NOC_TEMPLATE: "/noc/get_noc_template_pdf/",
  UPLOAD_SIGNED_NOC: "/noc/upload_signed_noc/",

  GET_NOC_STATUS: "/noc/get_noc_status/",
  GET_SIGNED_NOC: "/noc/get_signed_noc/",

  CREATE_SETTLEMENT: "/lms_loan/create_settlement_write_off/",
  GET_SETTLEMENT_WRITE_OFF: "/lms_loan/get_settlement_write_off/",
  UNDO_SETTLEMENT: "/lms_loan/undo_settlement/",
  SETTLEMENT_MOVE_TO_COMPLETE: "/lms_loan/settlement_move_to_complete/",
  MOVE_TO_SETTLEMENT: "/lms_loan/move_to_settlement/",
  SETTLEMENT_APPROVE: "/lms_loan/settlement_approve/",

  BL_UPLOAD_KYC: "/los_loan/add_borrower_identity/",
  BL_UPLOAD_DOCUMENTS: "/los_loan/add_or_get_borrower_document/",
  BL_DELETE_DOCUMENTS: "/los_loan/delete_business_document/",
  BL_VERIFY_DOC: "/los_loan/get_or_update_documents_information/",

  ADD_DEALER: "/team/add_dealer/",
  GET_ADD_DEALER_DOC: "/team/get_or_create_dealer_doc/",
  GET_DEALER_DETAILS: "/team/get_dealer_details/",

  ADD_UPDATE_VL_ASSET_DETAILS:
    "/vl_borrower/add_or_update_vehicle_asset_details/",
  GET_VL_BORROWER_DETAILS: "/admin/get_vl_borrower_details/",

  // Reports Panel
  GET_REPORTS_LIST: "/reports/get_reports_list/",
  GET_REPORTS_TYPE_LIST: "/reports/get_reports_type_list/",
  // Status choices for the Sign-up Users report (signup funnel + loan pipeline).
  GET_SIGNUP_REPORT_STATUS_OPTIONS: "/reports/signup_report_status_options/",
  // Borrower + loan detail for one lead (Leads list expanded row).
  GET_LEAD_EXTRA_DETAIL: "/dealer/get_lead_extra_detail/", // GET -- look_up_key: lead id
  GET_REPORT_FIELDS: "/reports/reports_fields/",
  CREATE_REPORT_TEMPLATE: "/reports/create_report_template/",
  GENERATE_REPORT: "/reports/create_report/",
  // Queue a spreadsheet of a list screen as a System report.
  CREATE_LIST_REPORT: "/reports/create_list_report/", // POST -- list_key, params, columns, title
  GET_STATUS_LIST: "/reports/get_report_stage_filters_list/",
  RENAME_REPORT: "/reports/rename_report/", // PATCH -- look_up_key: report id
  DELETE_REPORTS_TEMPLATE: "/reports/get_update_delete_report_template/",
  UPDATE_REPORTS_TEMPLATE: "/reports/get_update_delete_report_template/",
  GET_REPORTS_TEMPLATE: "/reports/get_update_delete_report_template/",

  // Leads
  DEALER_CREATE_LEAD: "/dealer/create_lead/",
  GENERATE_UTM_LINK: "/dealer/generate_utm_link/",
  DEALER_LIST_DEALER_LEADS: "/dealer/list_dealer_leads/",
  DEALER_CHANGE_LEAD_STATUS: "/dealer/change_lead_status/",
  DEALER_GET_LEAD_DETAILS: "/dealer/get_lead_details/",
  BORROWER_SEND_VERIFICATION_MAIL: "/borrower/send_verification_mail/",
  BORROWER_GET_VERIFICATION_DETAILS: "borrower/get_verification_details/", // GET -- lookup_key = verification_code,



//Loan Against Property
  ADD_LAP_PROPERTY_DETAILS:"/lap_borrower/create_or_update_property_detail/",
  GET_PROPERTY_DETAILS:"/lap_borrower/get_property_detail/",
  ADD_CO_BORROWER:"/bl_borrower/co_borrower_details/",

  //Dashboard
  // One endpoint per tab on the Dashboard screen. All five take the same filter
  // params, so switching tabs never changes what the figures are filtered by.
  GET_DASHBOARD_DATA:"/dashboard/summary/",
  GET_DASHBOARD_FUNNEL:"/dashboard/funnel/",
  GET_DASHBOARD_ORIGINATION:"/dashboard/origination/",
  GET_DASHBOARD_DISBURSEMENT:"/dashboard/disbursement/",
  GET_DASHBOARD_PORTFOLIO:"/dashboard/portfolio/",
  GET_DASHBOARD_PORTFOLIO_LOANS:"/dashboard/portfolio/loans/",
  GET_DASHBOARD_COLLECTIONS:"/dashboard/collections/",
  GET_DASHBOARD_COLLECTION_EMIS:"/dashboard/collections/emis/",
  GET_EDITABLE_VOUCHER_DATA:"/ledgers/get_dealer_voucher/",
  UPDATE_JOURNAL_VOUCHER:"/ledgers/update_dealer_voucher/",

  DEALER_LIST_DEALER_LEADS_BY_SUBSTATUS: '/dealer/list_dealer_leads_by_substatus/',
  DEALER_LIST_SIGNUP_STAGE_LEADS: '/dealer/list_signup_stage_leads/',

  //Settings
  GET_VERIFICATION_TYPES_LIST:"/master/get_verification_types_list/",
  GET_VERIFICATION_PARAMETERS_LIST:"/master/get_verification_parameters_list/",
  SUBMIT_VERIFICATION:"/verification/nbfc_criteria/bulk/",
  GET_NBFC_CRITERIA_BULK:"/verification/nbfc_criteria/",
  DELETE_NBFC_CRITERIA: '/verification/nbfc_criteria/',
  DELETE_NBFC_CRITERIA_VALUE: '/verification/nbfc_criteria/value/',
  GET_PAR_SCORE: "/verification/par_score/",
  UPSERT_PAR_SCORE: "/verification/par_score/",
  DELETE_PAR_SCORE: "/verification/par_score/", // DELETE -- params: verification_type, product_type (product rows only)
  ELIGIBLE_PINCODES: "/verification/eligible_pincodes/", // GET/POST/DELETE -- params/body: is_eligible, product_type
  ELIGIBLE_LOCATIONS: "/verification/eligible_locations/", // GET/POST/DELETE -- params/body: kind (state|city), product_type, mode (merge|replace)
  LOCATION_SAMPLE: "/verification/location_sample/", // GET -- params: kind (state); superseded by SERVICEABILITY_SHEET, kept for older builds
  // The sample sheet for a serviceability list, or everything on it today.
  SERVICEABILITY_SHEET: "/verification/serviceability_sheet/", // GET -- params: list (pincode-eligible|pincode-non-eligible|state|city), content (sample|current), product_type; .xlsx, rebuilt per request

  // NBFC configuration -- GET returns {groups:[{key,title,fields:[]}]},
  // PATCH takes a partial {key: value} map of the fields that changed.
  SETTINGS_PROFILE: "/settings/profile/", // GET / PATCH
  SETTINGS_FLAGS: "/settings/flags/", // GET / PATCH
  SETTINGS_CALLING: "/settings/calling/", // GET / PATCH -- Exotel click-to-call
  SETTINGS_RELOAN_CONFIG: "/settings/reloan_config/", // GET / PATCH -- params: product_type (optional)
  SETTINGS_NOC_CHARGES: "/settings/noc_charges/", // GET / PATCH -- params: product_type (optional)
  SETTINGS_AUTO_APPROVAL: "/settings/auto_approval/", // GET / PATCH -- params: product_type (required)
  SETTINGS_AUTO_ASSIGNMENT: "/settings/auto_assignment/", // GET / PATCH -- assignment method + daily limits
  SETTINGS_AUDIT: "/settings/audit/", // GET -- params: section, limit
  // Partner offers shown after a rejection. GET/POST on the base URL; a detail
  // or sub-action goes through look_up_key ("<id>", "<id>/revert",
  // "<id>/eligibility") since $Axios appends it as `url + lookUpKey + "/"`.
  SETTINGS_PARTNER_OFFERS: "/settings/partner_offers/", // GET/POST; PATCH/DELETE/PUT -- look_up_key
  SETTINGS_PARTNER_OFFERS_BY_DEALER: "/settings/partner_offers/by_dealer/", // GET/PATCH -- params/body: dealer
  SETTINGS_PARTNER_OFFERS_SYNC: "/settings/partner_offers/sync_now/", // POST
  // Home-screen banners in the borrower app. GET returns {banners, options};
  // POST (multipart) adds one; PATCH/DELETE via look_up_key "<id>", and
  // look_up_key "reorder" takes POST {order: [ids]}.
  SETTINGS_BANNERS: "/settings/banners/", // GET/POST; PATCH/DELETE -- look_up_key
  SETTINGS_PARTNER_OFFERS_CLICK_STATS: "/settings/partner_offers/click_stats/", // GET -- params: from, to (YYYY-MM-DD) -> {stats: {<id>: {offered, clicked_by, total_clicks}}}
  PARTNER_OFFER_CLICKS_LOS: "/partner_offers/clicks/lead/", // GET -- look_up_key: lead_creation -> {rejected_on, rejection_reason, shown, clicked, offers}
  PARTNER_OFFER_CLICKS_LEAD: "/partner_offers/clicks/dealer_lead/", // GET -- look_up_key: dealer lead id; same shape

  // Auto Assignment (Settings) -- <target> is lead | los | collection
  ASSIGNMENT_RULES: "/assignment/rules/", // GET/POST -- append `${target}/`
  ASSIGNMENT_RULE_DETAIL: "/assignment/rules/", // PATCH/DELETE -- `${target}/${id}/`
  ASSIGNMENT_DEFAULT: "/assignment/default/", // GET/PUT -- append `${target}/`
  ASSIGNMENT_FILTERS: "/assignment/filters/", // GET -- append `${target}/`
  ASSIGNMENT_PREVIEW: "/assignment/rules/", // POST -- `${target}/preview/`
  ASSIGNMENT_TEAM_LISTS: "/assignment/team_lists/", // GET/POST
  ASSIGNMENT_TEAM_LIST_DETAIL: "/assignment/team_lists/", // PATCH/DELETE -- append `${id}/`

  // LoanOpss Partner Portal -- public sign-in content and partner (DSA) sign-in.
  PARTNER_PORTAL: "/partner/portal/", // GET -- the portal's content
  PARTNER_FIND_LENDER: "/partner/portal/find/", // GET ?q=<NBFC name or code> -> {code}, 404 when none matches exactly
  PARTNER_SEND_OTP: "/partner/auth/send_otp/", // POST -- method (phone|email), value; the server finds the lender
  PARTNER_VERIFY_OTP: "/partner/auth/verify_otp/", // POST -- + otp -> token, partner {slug, nbfc_code}
  PARTNER_ME: "/partner/auth/me/", // GET -- the signed-in partner's profile, 403 for anything else
  PARTNER_OVERVIEW: "/partner/dashboard/overview/", // GET ?start_date&end_date -- the partner's own headline, charts and latest leads
  PARTNER_REPORT_OPTIONS: "/partner/reports/options/", // GET -- MIS filter choices from the partner's own leads + column preview
  PARTNER_MIS_REPORTS: "/partner/reports/mis/", // GET ?page -- own reports; POST -- generate (dealer pinned to the login)
  PARTNER_MIS_FILE: "/partner/reports/mis/", // GET `${id}/file/` -- download one of the partner's own reports
  PARTNER_MIS_VIEW: "/partner/reports/mis/", // GET `${id}/view/?page` -- the same file's rows, for the in-page viewer

  // Eligibility
  GET_BORROWER_VERIFICATION_DATA: "/verification/borrower_verification_data/", // GET -- params: loan_lead_creation, type
  GET_BORROWER_VERIFICATION_DATA_GROUPED: "/verification/borrower_verification_data/grouped/", // GET -- params: loan_lead_creation or borrower_id

  // Staff sessions: the signed-in teammate's own timer and logout, Session
  // History and the User Sessions board (orrish-backend staff_sessions/).
  SESSION_CURRENT: "/sessions/current/", // GET
  SESSION_LOGOUT: "/sessions/logout/", // POST {reason}
  SESSION_ACTION: "/sessions/action/", // POST {code}
  SESSION_MEMBERS: "/sessions/members/", // GET board; append `${id}/calendar/` (?month=) or `${id}/day/` (?date=)
};

export default apiUrl;
